var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserValidatedOld = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(4 4)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3675 10.161C7.27723 10.065 7.1527 10.0085 7.02101 10.0038C6.88931 9.99913 6.76108 10.0466 6.66422 10.136C6.56736 10.2253 6.50968 10.3493 6.50374 10.481C6.4978 10.6126 6.54408 10.7413 6.6325 10.839L8.4385 12.7985C8.707 13.0615 9.107 13.0615 9.3555 12.8135L9.5375 12.634C10.1948 11.9876 10.8513 11.3404 11.507 10.6925L11.527 10.6725C12.1398 10.0685 12.7495 9.46135 13.356 8.85099C13.4466 8.75609 13.4963 8.62936 13.4944 8.49814C13.4924 8.36692 13.4389 8.24174 13.3455 8.1496C13.252 8.05746 13.1261 8.00576 12.9949 8.00565C12.8636 8.00553 12.7376 8.05702 12.644 8.14899C12.0403 8.75616 11.4337 9.36034 10.824 9.96149L10.804 9.98149C10.1756 10.6026 9.54647 11.223 8.9165 11.8425L7.3675 10.161Z",
    fill: "#F8F9FB",
    stroke: "#F8F9FB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserValidatedOld);
export default ForwardRef;